import React, { PureComponent } from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import {
  // is,
  Map
} from 'immutable'
import {
  TYPES,
  FORM_STYLES
} from '../types'
import {
  FIELD_OPTIONS_SHAPE,
  CUSTOM_INPUTS_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'
import Input from './Input'
import FieldSet from './FieldSet'
import FieldSetSchema from '../FieldSetSchema'
import NestedCollection from './NestedCollection'

/*
 * Schemer.Inputs
 *
 * returns an array of elements based on the given schema and initialValues/pendingValues
 */
export default class Inputs extends PureComponent {
  static displayName = 'Schemer.Inputs'

  static propTypes = {
    readOnly: T.bool.isRequired,
    style: T.oneOf(Object.keys(FORM_STYLES)),
    schema: SCHEMA_SHAPE.isRequired,
    // pendingValues: IT.map,
    // initialValues: IT.map,
    currentValues: IT.map,
    onChange: T.func.isRequired,
    onChangeArgs: T.array,
    onValidationChange: T.func.isRequired,
    onFocus: T.func,
    onBlur: T.func,
    customInputs: CUSTOM_INPUTS_SHAPE,
    fieldOptions: FIELD_OPTIONS_SHAPE
  }

  static defaultProps = {
    // pendingValues: Map()
  }

  state = {
  }

  handleChange = (newValue, fieldName) => {
    const {
      onChange,
      onChangeArgs=[]
    } = this.props
    onChange(newValue, fieldName, ...onChangeArgs)
  }

  handleValidationChange = (validationMsg, fieldDisplay, fieldName) => {
    const {
      onValidationChange,
      onChangeArgs=[]
    } = this.props
    // console.log('Inputs ~~~~handleValidationChange', fieldDisplay, fieldName, validationMsg, onChangeArgs)

    onValidationChange(validationMsg, fieldDisplay, fieldName, ...onChangeArgs)
  }

  render() {
    const {
      schema,
      readOnly,
      style,
      currentValues,
      customInputs,
      onBlur,
      onFocus,
      fieldOptions
    } = this.props

    if (!schema) {
      return
    }

    return schema.getEditable().entrySeq().reduce((out, [fieldKey, field]) => {
      // && field.has('schema')) {
      if (field.get('type') === TYPES.SCHEMA) {
        out.push(
          <NestedCollection
            key={fieldKey}
            schema={field.get('schema')}
            fieldName={fieldKey}
            field={field}
            onChange={this.handleChange}
            onValidationChange={this.handleValidationChange}
            currentValue={currentValues.get(fieldKey)}
            {...{
              readOnly,
              style,
              customInputs,
              fieldOptions
            }}
          />
        )
      }
      else if (fieldKey instanceof FieldSetSchema) {
        const fieldSetSchema = fieldKey
        out.push(
          <FieldSet
            key={fieldKey.get('id')}
            fieldSetSchema={fieldSetSchema}
            fields={field}
            schema={schema}
            onChange={this.handleChange}
            onValidationChange={this.handleValidationChange}
            currentValues={currentValues.filter((v, k) => field.has(k))}
            {...{
              readOnly,
              style,
              customInputs,
              fieldOptions
            }}
          />
        )
      }
      else {
        out.push(
          <Input
            key={fieldKey}
            fieldName={fieldKey}
            field={field}
            schema={schema}

            currentValue={currentValues.get(fieldKey)}

            onChange={this.handleChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onValidationChange={this.handleValidationChange}

            readOnly={readOnly}
            style={style}

            customInputs={customInputs}
            fieldOptions={fieldOptions}
          />
        )
      }
      return out
    }, [])

  }
}